enum CheckoutStepType {
    Billing = 'billing',
    Customer = 'customer',
    Payment = 'payment',
    Shipping = 'shipping',
    RPAL = 'rpal'
}

export default CheckoutStepType;
